<template>
  <div class="index-container">
    <Header :nosearch="true" :title="`用户协议`"/>
    <div class="protocol-wrap">
      <h3>用户协议</h3>

      <div>甲方：富利港美股</div>
      <div>乙方：用户</div>
      <p>甲方和乙方就用户服务等相关内容达成以下共识，并由双方共同恪守，具体内容如下：</p>
      <p>
        <b>
          【
          <span class="app-name">富利港美股网站</span>】
        </b>是甲方旗下平台，在乙方正式使用甲方平台及其相关服务（包括甲方通过甲方平台现在正在提供和将来可能向乙方提供的服务）前，请乙方务必认真阅读并充分理解《用户协议》（以下简称“本协议”）的内容，
        <u>
          <b>特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示乙方注意，乙方应重点阅读。</b>
        </u>
      </p>
      <p>
        <u>
          <b>若乙方为无民事行为能力人或为限制民事行为能力人，乙方应告知其监护人，并应在乙方监护人的指导下阅读本协议和使用甲方平台及其相关服务。</b>
        </u>
      </p>
      <p>
        <u>
          <b>若乙方是中国大陆以外的用户，乙方应同时遵守其所属国家或地区的法律，且乙方确认，订立并履行本协议不受乙方所属、所居住或开展经营活动或其他业务的国家或地区法律法规的限制。</b>
        </u>
      </p>
      <p>
        <u>
          <b>除非乙方完全接受本协议的全部内容，否则乙方无权下载、安装、注册、登录、使用（以下统称“使用”）甲方平台，或者通过任何方式使用甲方平台的服务，或者获得甲方平台提供的任何服务。</b>
        </u>
      </p>
      <p>
        <u>
          <b>若乙方勾选“我已阅读并同意签订《用户服务协议》”并以点击确认的形式进行下一步操作，则视为乙方已充分理解本协议并承诺作为本协议的一方当事人接受协议的约束。</b>
        </u>
      </p>

      <h5>一、适用范围</h5>

      <p>1．本协议:乙方与甲方之间就乙方使用甲方平台，并获得甲方平台提供的相关服务所订立的协议，包括但不限于甲方已经发布及后续可能不断发布的关于甲方平台及相关服务的协议、规则，前述协议、规则一经发布，甲方将以适当的方式（系统提示、网站公告等）提醒乙方及时阅读，所有协议、规则构成本协议不可分割的组成部分，乙方应遵守。</p>
      <p>根据法律法规、技术条件、产品功能等变化，甲方可以修改本协议。修改的内容一经发布，甲方将以适当的方式（系统提示、网站公告等）提醒乙方及时阅读。所有修改的内容将构成本协议不可分割的组成部分，乙方应遵守。</p>
      <p>若乙方对修改的协议有异议的，请立即停止登录、使用甲方平台及相关服务，若乙方登录或继续使用甲方平台及相关服务，视为认可修改后的协议。</p>

      <p>
        2．甲方平台:
        指由甲方合法拥有并运营的、标注名称为
        <u>
          <b>
            “【
            <span class="app-name">富利港美股网站</span>】”
          </b>
        </u>的包括但不限于应用程序、网站、微信公众号/小程序。甲方可以对应用程序、网站、微信公众号/小程序的名称单方变更（包括但不限于更名、新增）；
      </p>
      <p>平台服务：指甲方在向乙方使用甲方平台时向其提供的服务，包括但不限于信息展示、信息支持、日常运营维护服务，具体见本协议第八条。</p>
      <p>
        <u>
          <b>3．乙方同意并确认：甲方可以依甲方平台及相关服务或运营的需要单方决定，安排或指定其成员机构、关联实体及合作伙伴继续运营甲方平台。并且，就本协议项下涉及的某些平台服务，可能会由甲方的成员机构、关联实体及合作伙伴向乙方提供。乙方知晓并同意接受并使用相关服务内容，即视为接受相关权利义务关系亦受本协议约束。</b>
        </u>
      </p>

      <h5>二、服务说明</h5>

      <p>1．甲方平台仅为乙方提供平台服务。乙方应当自行配备上网的所需设备（如个人电脑、手机、调制解调器或其他必备上网装置）及所需费用（如上网所支付的与此服务有关的电话费用、网络费用、手机费用等）。</p>
      <p>基于甲方或/和甲方平台所提供的服务的重要性，乙方应同意：</p>
      <p>(1)提供真实、准确、完整的个人信息；</p>
      <p>(2)不断更新个人资料，符合真实、准确、完整的要求。</p>
      <p>2．乙方可以通过包括但不限于本人手机号、本人微信及本人微博登录使用甲方平台及相关服务。</p>
      <p>
        <u>
          <b>乙方同意并确认：为使乙方更好地使用甲方平台及相关服务，保障乙方的账户安全，某些功能和/或某些单项服务项目。乙方应根据国家法律法规的规定，提供真实且必要的身份信息实名使用。</b>
        </u>
      </p>
      <p>如乙方发现甲方平台存在侵犯其权利的内容，请立即通知甲方并提供相关权利的证明材料。</p>

      <p>3．乙方使用甲方平台及相关服务，可以通过包括但不限于预装、甲方已授权的第三方下载获取客户端应用程序或访问甲方平台网站。若乙方并非从甲方或经甲方授权的第三方获取甲方平台及相关服务的，甲方不保证正常使用，不承担以此产生责任和损失。</p>

      <p>4．甲方可能为不同的终端设备开发了不同的应用程序版本，乙方应当根据实际设备状况获取、下载、安装合适的版本。</p>

      <p>5．乙方可按照自行需要使用甲方平台及相关服务或更新版本，如乙方不再需要使用甲方平台及相关服务的，可自行卸载。</p>

      <p>6．未经甲方书面同意，乙方不得以任何形式对甲方平台及相关服务进行包括但不限于改编、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。</p>

      <p>7．甲方许可乙方可撤销的、不可转让的、非独占地和非商业的合法使用甲方平台及相关服务。本协议未明示授权的其他一切权利仍由甲方保留，乙方在行使该些权利时须另行获得甲方书面许可，同时甲方如未行使前述任何权利，并不构成对该权利的放弃。</p>

      <h5>三、服务的变更、中断或终止</h5>
      <p>1．为了甲方平台的正常运行，甲方平台可以定期或不定期地对甲方平台（包括但不限于应用程序、网站、微信公众号/小程序）或相关的设备进行检修、维护或改变（包括但不限于软件修改、升级、功能强化、开发新服务、软件替换），甲方平台及相关服务更新或部分服务内容更新后，甲方平台可以通过包括但不限于系统提示、网站公告提示乙方，乙方可以选择接受更新版本或服务，如乙方不接受，部分功能将受到限制或不能继续使用；如因此类情况而造成甲方平台及相关服务在合理时间内的中断，甲方不为此承担任何责任。</p>
      <p>
        2．
        <u>
          <b>如发生下列任何一种情形，甲方平台可以随时中断或终止向乙方提供甲方平台及相关服务而不对乙方或任何第三方承担任何责任：</b>
        </u>
      </p>
      <p>(1) 乙方提供的资料不真实；</p>
      <p>(2) 乙方违反本协议约定；</p>
      <p>(3) 乙方违反《行为守则》等平台有关规定（如有）。</p>

      <h5>四、网上登入</h5>
      <p>1．乙方在使用甲方平台及相关服务时，应当向甲方平台提供真实、准确、完整及最新的个人信息（包括但不限于姓名、身份证号、联系电话、电子邮箱等），如个人信息有任何变动，必须及时更新；</p>
      <p>因乙方个人信息不完整、不真实、不准确，则无法使用甲方平台及相关服务；因乙方个人信息不完整、不真实、不准确、个人信息未及时更新而产生的一切后果，由乙方自行承担，甲方不就此承担任何责任。</p>

      <p>2．乙方在此同意接受甲方或/和甲方平台通过电子邮件或其他方式向乙方发送宣传推广或者其他相关商业信息。</p>

      <p>3．在不对外披露乙方隐私资料的前提下，甲方或/和甲方平台可以对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>

      <p>4．乙方作为甲方平台用户，应当遵守《全国人大常委会关于加强网络信息保护的决定》等法律法规。</p>
      <p>
        5．
        <u>
          <b>乙方确认其具有完全民事行为能力，若乙方不满足相应条件、故意隐瞒、冒用第三方身份使用甲方平台及相关服务的，自行承担相关责任；如乙方授权第三方使用甲方平台及相关服务的，甲方将视为乙方本人自己的操作，乙方自行承担因此产生的全部后果；</b>
        </u>
      </p>
      <p>
        <u>
          <b>若乙方不具备完全民事行为能力，需由乙方的法定代理人（或监护人）阅读、了解且同意本协议全部条款。</b>
        </u>
      </p>

      <h5>五、账号管理</h5>
      <p>1．甲方平台为乙方提供了登入通道（包括但不限于通过本人手机号、本人微信及本人微博），乙方可以选择合法的字符组合作为自己的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是确定用户身份、使用甲方平台及相关服务的凭证。</p>
      <p>2．乙方应维护其账户的安全性与保密性，妥善保管其账号、密码及相关数据，对其账户发生的所有活动和事件负责，包括但不限于乙方在平台上进行的任何数据修改、言论发表、款项支付等行为。</p>
      <p>
        3．乙方不得将账户转让或借予第三方使用。如乙方发现其账户遭第三方非法使用，应立即通知甲方或/和甲方平台。因黑客行为或乙方的保管疏忽导致账户遭第三方非法使用，甲方或/和甲方平台不承担任何责任。
        <u>
          <b>如果甲方发现或者有合理理由认为使用者并非账户开设人，甲方可以在未通知乙方的情况下，暂停或终止向该账户提供服务，并可以注销该账户，而不承担任何责任。</b>
        </u>
      </p>
      <p>
        4．
        <u>
          <b>乙方注销账户的，乙方知悉并确认：</b>
        </u>
      </p>
      <u>
        <b>
          <p>（1）乙方仅能申请其本人账户，并依照甲方平台流程进行注销；</p>
          <p>（2）乙方应对其在注销账户前使用甲方平台及相关服务的行为负责；</p>
          <p>（3）乙方确认并同意：账户注销成功后，包括不限于账号记录、功能等无法恢复或提供。</p>
        </b>
      </u>
      <p>5．乙方理解并承诺，乙方所设置的账户不得违反国家法律法规及甲方的相关规则，乙方的账号名称、头像和简介等信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得使用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意开设账号（包括但不限于频繁开设、批量开设账号）。乙方在账号开设及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。甲方可以对乙方提交的账户信息进行审核。</p>
      <p>6．在使用和管理账户时，乙方应保证注册账户时填写的身份信息的真实性，请乙方在管理账户时使用真实、准确、合法、有效的相关身份证明材料及必要信息（包括但不限于乙方的姓名及电子邮件地址、联系电话、联系地址）。</p>
      <p>根据国家法律法规的规定，为使用甲方平台及相关服务，如果需要乙方填写真实的身份信息，请乙方根据相关法律规定完成实名认证，并注意及时更新上述相关信息。若乙方提交的材料或提供的信息不准确、不真实、不合法或者甲方有理由怀疑为错误、不实或不合法的资料，则甲方可以拒绝为乙方提供相关服务或乙方可能无法使用甲方平台及相关服务或在使用过程中部分功能受到限制。</p>

      <h5>六、用户隐私制度</h5>
      <p>
        1.
        甲方仅收集与乙方使用平台及相关服务相关的个人信息及资料（包括但不限于姓名、性别、年龄、身份证号、联系电话、电子邮箱、购买记录等），甲方将逐一说明甲方平台向乙方提供的业务功能，以及该等功能所对应的需要收集的乙方的个人信息，以助于甲方提供服务。
      </p>
      <p>
        基于本条第一款的目的，
        <u>
          <b>乙方知悉并确认：甲方可以将乙方的个人信息及资料转交至甲方的成员机构、关联实体及合作伙伴，但上述成员机构、关联实体及合作伙伴应对乙方相关信息保密。</b>
        </u>
      </p>
      <p>
        <u>
          <b>
            2.
            乙方知悉并确认，若乙方勾选“我已阅读并同意签订《用户服务协议》”并以点击确认的形式进行下一步操作，则视为乙方已充分理解本协议并承诺作为本协议的一方当事人接受协议的约束，乙方同意甲方按照本条约定收集、使用、储存、和分享乙方的相关信息。
          </b>
        </u>
      </p>
      <p>
        3. 尊重和保护乙方隐私是甲方的一项基本政策，甲方保证不对外公开或向第三方提供乙方的个人资料，
        <u>
          <b>但下列情况除外：</b>
        </u>
      </p>
      <p>(1) 事先获得乙方明确同意，或按照乙方要求签订和履行合同所必需的；</p>
      <p>(2) 作为合并、收购、资产转让或类似交易的一部分而转移；</p>
      <p>(3) 与国家安全、国防安全直接相关的；</p>
      <p>(4) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>(5) 乙方自行向其他公司、组织和个人共享、转让、公开的；</p>
      <p>
        (6)
        根据法律法规的规定、司法行政机构要求所必须的情况下进行披露或提供，或与犯罪侦查、起诉、审判和判决执行等直接相关的。在符合法律法规的前提下，当甲方收到前述披露信息的请求时，甲方会要求对方必须出具与之相应的法律文件，包括但不限于传票或调查函。甲方将对所有的请求都进行了审慎的审查，以确保其具备合法依据，且仅限于行政、司法部门因特定调查目的有合法权利获取的数据；
      </p>
      <p>(7) 为维护乙方、他人、甲方、甲方员工及甲方成员机构、关联实体及合作伙伴的生命、财产等合法权益，包括但不限于查找、预防、处理欺诈等违法活动和减少信用风险；</p>
      <p>(8) 为维护所提供的服务的安全稳定运行所必需，包括但不限于发现、处置服务的故障；</p>
      <p>(9) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>(10) 法律法规规定的或其他合理情形。</p>
      <p>4. 请乙方注意勿在使用甲方平台及相关服务中透露自己的各类财产账户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此带来的任何损失由乙方自行承担。</p>
      <p>更多关于用户个人信息保护的内容，请参看《隐私政策》。</p>

      <h5>七、对用户的管理</h5>
      <p>
        1．
        <u>
          <b>乙方在使用甲方平台及相关服务过程中，必须遵循以下原则：</b>
        </u>
      </p>
      <p>(1) 乙方不得委托甲方及其员工对乙方账户进行任何操作，由此引起的一切后果由乙方自负。</p>
      <p>(2) 遵守中华人民共和国现行法律、行政法规和其他规范性文件；</p>
      <p>(3) 不得为任何非法目的而使用平台服务系统；</p>
      <p>(4) 遵守所有甲方平台的网络协议、规定、程序和惯例；</p>
      <p>(5) 不得发表、散布、传播任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗的、淫秽的、教唆他人实施犯罪行为等非法的信息资料；若乙方在甲方平台发表、散布和传播上述信息，甲方平台的系统记录可以作为乙方违反法律法规的证据；</p>
      <p>(6) 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；</p>
      <p>(7) 不得利用甲方或/和甲方平台服务系统进行任何不利于甲方或/和甲方平台的行为；</p>
      <p>(8) 不得窃取或者以其他非法方式获取他人个人信息，不得非法出售或者非法向他人提供个人信息；</p>
      <p>(9) 应当对其使用网络的行为负责，不得设立用于实施诈骗，传授犯罪方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，不得利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息；</p>
      <p>
        2．
        <u>
          <b>乙方应对其使用甲方平台及相关服务的行为负责，除非根据法律法规规定或经甲方书面同意，乙方不得具有下列行为：</b>
        </u>
      </p>
      <p>(1) 使用未经甲方授权或许可的任何插件、外挂、系统或第三方工具对甲方平台及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
      <p>(2) 利用或针对甲方平台及相关服务进行任何危害计算机网络安全的行为，包括但不限于：</p>
      <p>A.非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的活动；</p>
      <p>B.提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；</p>
      <p>C.明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；</p>
      <p>D.使用未经许可的数据或进入未经许可的服务器/账号；</p>
      <p>E.未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；</p>
      <p>F.未经许可，企图探查、扫描、测试甲方平台系统或网络的弱点或其它实施破坏网络安全的行为；</p>
      <p>G.企图干涉、破坏甲方平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；</p>
      <p>H.伪造TCP/IP数据包名称或部分名称。</p>
      <p>(3) 对甲方平台进行反向工程、反向汇编、编译或者以其他方式尝试发现甲方平台的源代码。</p>
      <p>(4) 恶意注册甲方平台账号，包括但不限于频繁、批量注册账号。</p>
      <p>(5) 违反法律法规、本协议、甲方的相关规则及侵犯他人合法权益的其他行为。</p>
      <p>在任何情况下，如果甲方有理由认为乙方的任何行为违反或可能违反上述约定的，甲方可独立进行判断并处理，且在任何时候可以终止向用户提供服务，并追究相关责任。</p>

      <u>
        <b>
          <p>3．甲方或/甲方平台可以对乙方使用甲方平台及相关服务情况进行审查和监督，如乙方在使用甲方及相关平台服务时违反任一上述规定，甲方或/和甲方平台可以要求乙方改正或直接采取一切必要的措施（包括但不限于暂停或终止乙方使用甲方平台及其相关服务等）以减轻乙方不当行为造成的影响。</p>
          <p>
            4．
            甲方或/甲方平台不对乙方所发布信息的删除或储存失败承担任何责任。甲方或/甲方平台可以判定乙方的行为是否符合中华人民共和国法律法规的规定以及本协议的要求，如果乙方违背了中华人民共和国法律法规的规定或服务条款的规定，甲方或/甲方平台有中断对其提供服务的权利。
          </p>
        </b>
      </u>
      <p>5． 乙方在使用甲方平台及相关服务时，应遵守《行为守则》等平台有关规定（如有）。</p>

      <h5>
        <b>八、平台服务内容</b>
      </h5>
      <p>
        <u>
          <b>甲方的平台服务的具体内容由甲方根据实际情况提供。甲方可以随时变更、中断或终止部分或全部平台服务。</b>
        </u>
      </p>

      <h5>九、平台服务费用</h5>
      <p>
        1. 甲方在提供平台服务时，可能会对部分服务收取一定的费用。在此情况下，
        <u>
          <b>甲方在相关页面上做明确的提示。</b>
        </u>如乙方拒绝支付该等费用，则不能使用相关的平台服务。
      </p>
      <p>
        <u>
          <b>2. 甲方可以就其提供的平台服务制定、变更及豁免相关服务费用，具体费用以乙方使用相关平台服务时甲方平台或产品页面上所列的收费方式公告或乙方与甲方达成的其他书面协议为准。</b>
        </u>
      </p>

      <h5>十、第三方链接</h5>
      <p>
        甲方平台内可能设有链接至第三方提供的信息和服务（包括网站，下同），但这些网站和网页并非由甲方或/和甲方平台经营或控制，甲方或/和甲方平台不承担责任。
        <u>
          <b>乙方启动任何此类链接，离开甲方平台进入第三方网站或网页，所有风险自负，甲方不承担任何责任。</b>
        </u>
      </p>
      <p>
        <u>
          <b>乙方知悉并理解，提供该等信息和服务的第三方可能会要求乙方提供个人信息。甲方特别提醒乙方，需要认真阅读该等第三方的用户协议、隐私政策以及其他相关的条款，妥善保护自己的个人信息，仅在必要的情况下向该等第三方提供。本协议不适用于任何第三方提供的信息或服务，甲方对任何因乙方提供个人信息而获得的第三方信息或服务所引起的后果不承担任何责任。</b>
        </u>
      </p>

      <h5>十一、单项服务</h5>
      <p>
        <u>
          <b>
            1．
            乙方知悉并确认：单项服务由甲方合作的第三方合法运营并向乙方提供，甲方平台仅为第三方的服务内容提供信息展示，并为第三方和乙方之间提供信息支持及提供平台的日常运营维护服务。这些服务在甲方平台可能以单独板块形式存在。甲方可以不时地增加、减少或改动这些单项服务板块的设置及服务。
          </b>
        </u>
      </p>
      <p>
        2．
        乙方可以在甲方平台中开启和使用上述单项服务功能。某些单项服务可能需要乙方同时接受就该服务特别制订的协议或者其他约束乙方与该项服务提供者之间的规则。
        <u>
          <b>甲方将以醒目的方式提供这些协议、规则供乙方查阅。一旦乙方开始使用上述服务，则视为乙方同时接受有关单项服务的相关协议、规则的约束。</b>
        </u>
      </p>
      <p>
        3．乙方在甲方平台中使用第三方提供的软件及相关服务时，除遵守本协议及甲方平台的相关规则外，还应遵守第三方的协议、相关规则。
        <u>
          <b>如因第三方软件及相关服务产生的争议、损失或损害，由乙方自行与第三方解决。</b>
        </u>
      </p>

      <h5>十二、免责声明</h5>
      <u>
        <b>
          <p>乙方同意对甲方平台及相关服务的使用承担全部风险，并对因其使用甲方平台及相关服务而产生的一切后果承担全部风险，甲方对乙方不作任何类型的担保，也不承担任何责任。甲方不担保甲方平台及其相关服务一定能满足乙方的要求，也不担保甲方平台及其相关服务不会中断，对服务的及时性、安全性、准确性均不作担保。对于因不可抗力、甲方不能避免或控制的原因造成的甲方平台及其相关服务中断或其它缺陷，甲方不承担任何责任，但将尽力减少因此给乙方造成的损失和影响。</p>
          <p>甲方平台及相关服务所涉及的任何内容以及任何操作仅供乙方参考和学习使用，不构成投资建议，不具有任何投资咨询信息性质，不构成对包括但不限于股票、债券、期货、期权等任何金融产品的收购、购买、认购、抛售或持有的要约、要约邀请或承诺，不应成为乙方做出任何投资或其他决定的依据，甲方或/和甲方平台不承诺乙方获得投资收益，也不与乙方约定分享投资收益或分担投资损失，乙方已充分了解其合法合规性，甲方或/和甲方平台不作任何担保。乙方应自主做出投资决策，乙方应自行承担相应的投资风险和损失。</p>
          <p>乙方应了解证券、期货等金融市场的内涵和基本规则，甲方提供的所有数据与信息仅供乙方参考，乙方应自主做出投资决策并自行承担投资风险。</p>
          <p>证券、期货等金融市场具有较强的风险，甲方不能保证乙方盈利，也不承诺乙方的投资不遭受损失，甲方不对乙方任何的投资决策和投资行为负责。</p>
          <p>就单项服务，甲方平台仅为第三方的服务内容提供信息展示，并为第三方和乙方之间提供信息支持及提供平台的日常运营维护服务，不开展证券、期货投资咨询业务，该服务内容与甲方或/和甲方平台没有任何关系，甲方不承担任何责任。</p>
        </b>
      </u>

      <h5>十三、违约责任</h5>
      <p>1．如因甲方违反有关法律、法规或本协议项下的任何条款而给乙方造成损失，甲方应当承担由此造成的损害赔偿责任。</p>
      <p>2．乙方应当保障和维护甲方或/和甲方平台及任何其他用户的利益，如因乙方违反有关法律、法规或本协议项下的任何条款而给甲方或/和甲方平台及其他用户造成损失，乙方应当承担由此造成的损害赔偿责任。</p>
      <p>3．甲方或/和甲方平台对乙方使用甲方平台及其相关服务所产生的任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用甲方平台及其相关服务、在网上购买商品或进行同类型服务、在网上进行交易、非法使用甲方平台及其相关服务或乙方传送的信息有所变动等。</p>

      <h5>十四、侵权责任</h5>
      <p>乙方利用网络侵害他人民事权益的，应当承担侵权责任。乙方利用甲方或/和甲方平台实施侵权行为的，被侵权人可以通知甲方或/和甲方平台采取删除、屏蔽、断开链接等必要措施。</p>

      <h5>十五、知识产权</h5>
      <p>甲方平台（包括但不限于平台软件的结构、组织、代码及软件中所含的图像、照片、动画、录像、录音、音乐、文字和附加程序）、附随的印刷材料、及平台任何复制品、副本的著作权，均由甲方拥有。</p>
      <p>
        <u>
          <b>
            乙方勾选“我已阅读并同意签订《用户服务协议》”并以点击确认的形式进行下一步操作，即表明乙方主动将其在任何时间段在甲方平台发表的任何形式的信息的著作财产权，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给甲方所有，同时表明乙方许可甲方可以就任何主体侵权而单独提起诉讼，并获得全部赔偿。
            本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于乙方在甲方平台发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。
          </b>
        </u>
      </p>
      <p>本协议对乙方使用甲方平台服务的授权并不意味着著作权人对其享有的知识产权也进行了转让或进行独家授权使用。</p>

      <h5>十六、不可抗力</h5>
      <p>1. 不可抗力：指不能预见、不能克服、不能避免的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等，社会事件如战争、动乱、政府行为、国家政策变动等，罢工，网络通讯中断/故障，黑客攻击，电力故障等。</p>
      <p>
        <u>
          <b>2. 因不可抗力、下列不可控制情形造成的平台服务中断、受阻及其它缺陷，甲方不承担任何责任，但将尽力减少因此而给乙方造成的损失和影响，但是由此给乙方造成的损失，甲方不承担任何责任：</b>
        </u>
      </p>
      <p>(1) 出现第三方蓄意破坏、技术发展限制、政府禁令、监管机构要求、病毒、木马、黑客/恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、信息源异常、卫星传输线路故障、银行原因 、支付通道原因、第三方服务瑕疵等；</p>
      <p>(2) 乙方的电脑软件、系统、硬件、卫星传输线路故障、通信线路出现故障；</p>
      <p>(3) 乙方操作不当；</p>
      <p>(4) 乙方通过非甲方授权的方式使用平台服务；</p>
      <p>(5) 其他甲方不能控制的原因造成的情形。</p>

      <h5>十七、适用法律和争议解决</h5>
      <p>1.有关本协议的签订和履行而产生的任何争议及对本协议项下条款的解释，均适用中华人民共和国法律法规（为本协议之目的，在此不包括香港、澳门特别行政区及台湾地区法律法规），并按其解释。</p>
      <p>
        <u>
          <b>2.本协议的签订地点为中华人民共和国上海市浦东新区，因本协议引起或与本协议有关的一切争议，双方均应友好协商解决；如不能解决，由上海市浦东新区人民法院管辖。</b>
        </u>
      </p>
      <p>3.协商或诉讼期间，双方应本着诚信原则继续履行本协议无争议部分。双方为诉讼而实际支付的费用（包括但不限于诉讼费用、律师费）由败诉方承担。</p>

      <h5>十八、其他规定</h5>
      <p>
        <u>
          <b>1．本协议以电子合同进行签订，凡乙方勾选“我已阅读并同意签订《用户协议》”并以点击确认的形式进行下一步操作，则视为乙方已充分理解本协议并承诺作为本协议的一方当事人接受协议的约束。</b>
        </u>
      </p>
      <p>2．如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
      <p>3．本协议条款中的标题仅为方便而设，在解释本协议条款时应被忽略。</p>
      <p>4．甲方提供的平台服务的所有权、运营权和最终解释权归甲方所有。</p>
    </div>
    <div class="statement-wrap">
      <h3>免责声明</h3>
      <div class="content">
        <p>
          在正式使用
          <span class="key-point underline">
            <span class="app-name">富利港美股网站</span>
            <span>
              （以下简称“平台”）的服务前，请您（以下或称“用户”）务必认真阅读《免责声明》的内容，
              <span
                class="key-point underline"
              >特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。</span>
            </span>
          </span>
        </p>
        <p
          class="key-point underline"
        >若您勾选“我已阅读并同意签订《免责声明》”并以点击确认的形式进行下一步操作，则视为您已充分理解本《免责声明》并承诺接受本《免责声明》的约束，如您存在异议，请放弃勾选或/和点击确认。</p>
        <p
          class="key-point underline"
        >除非您完全接受本《免责声明》的全部内容，否则您无权下载、安装、注册、登录、使用（以下统称“使用”）平台，或者通过任何方式使用平台的服务，或者获得平台提供的任何服务。</p>
        <p class="key-point">
          1.
          本平台所涉及的任何内容以及任何操作仅供用户参考和学习使用，不构成投资建议，不具有投资咨询性质，不构成对包括但不限于股票、债券、期货、期权等任何金融产品的收购、购买、认购、抛售或持有的要约、要约邀请或承诺，不应成为用户做出任何投资或其他决定的依据，不承诺用户获得投资收益，也不与用户约定分享投资收益或分担投资损失，用户已充分了解其合规性，新浪时金或/和平台不作任何担保。用户应自主做出投资决策，用户应自行承担相应的投资风险和损失。
        </p>
        <p class="key-point">用户应了解证券期货市场的内涵和基本规则，平台提供的所有数据与信息仅供用户参考，用户应自主做出投资决策并自行承担投资风险。</p>
        <p class="key-point">证券期货市场具有较强的风险，平台不能保证用户盈利，也不承诺用户的投资不遭受损失，平台不对用户任何的投资决策和投资行为负责。</p>
        <p class="key-point">2. 因不可抗力、不可控制情形造成的平台服务中断、受阻及其它缺陷，平台不承担任何赔偿责任。</p>
        <p
          class="key-point"
        >3. 保护用户隐私是平台的一项基本政策，平台保证不对外公开或向第三方提供用户的注册资料及用户在使用平台服务时存储在平台的非公开内容，但下列情况除外：</p>
        <p class="key-point">(1) 事先获得用户明确同意，或按照用户要求签订和履行合同所必需的；</p>
        <p class="key-point">(2) 作为合并、收购、资产转让或类似交易的一部分而转移；</p>
        <p class="key-point">(3) 与国家安全、国防安全直接相关的；</p>
        <p class="key-point">(4) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="key-point">(5) 用户自行向其他公司、组织和个人共享、转让、公开的；</p>
        <p class="key-point">
          (6)
          根据法律法规的规定、司法行政机构要求所必须的情况下进行披露或提供，或与犯罪侦查、起诉、审判和判决执行等直接相关的。在符合法律法规的前提下，当平台收到前述披露信息的请求时，平台会要求对方必须出具与之相应的法律文件，包括但不限于传票或调查函。平台将对所有的请求都进行了审慎的审查，以确保其具备合法依据，且仅限于行政、司法部门因特定调查目的有合法权利获取的数据；
        </p>
        <p
          class="key-point"
        >(7) 为维护用户、他人、平台、平台员工及平台成员机构、关联实体及合作伙伴的生命、财产等合法权益，包括但不限于查找、预防、处理欺诈等违法活动和减少信用风险；</p>
        <p class="key-point">(8) 为维护所提供的服务的安全稳定运行所必需，包括但不限于发现、处置服务的故障；</p>
        <p class="key-point">(9) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p class="key-point">(10) 法律法规规定的或其他合理情形。</p>
        <p class="key-point">
          4.
          平台对用户使用平台服务所产生的任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用平台服务、在网上购买商品或进行同类型服务、在网上进行交易、非法使用平台服务或用户传送的信息有所变动。
        </p>
        <p class="key-point">
          5.
          用户同意对平台服务的使用承担全部风险，并对因其使用平台服务而产生的一切后果承担全部风险，平台对用户不作任何类型的担保，也不承担任何责任。平台不担保平台服务一定能满足用户的要求，也不担保平台服务不会中断，对服务的及时性、安全性、准确性均不作担保。
        </p>
        <p class="key-point">6. 平台不保证，包括但不限于：</p>
        <p class="key-point">(1) 平台服务适合用户的使用要求；</p>
        <p class="key-point">(2) 平台服务不受干扰，及时、安全、可靠或不出现错误；</p>
        <p class="key-point">(3) 用户经由平台服务取得的任何产品、服务或其他符合用户期望材料。</p>
        <p class="key-point">7. 用户使用经由平台下载的或取得的任何资料，其风险自行负担；因该使用而导致用户电脑系统损坏或资料流失，用户自行承担责任。</p>
        <p class="key-point">8. 基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，平台不承担任何直接、间接、附带、衍生或惩罚性的赔偿。</p>
        <p class="key-point">(1) 平台服务使用或无法使用；</p>
        <p class="key-point">(2) 经由平台服务购买或取得的任何产品、资料或服务；</p>
        <p class="key-point">(3) 用户资料遭到未授权的使用或修改；</p>
        <p class="key-point">(4) 其他与平台服务相关的事宜。</p>
        <p class="key-point">
          9.
          平台可以暂时或永久地修改或终止平台全部服务（或任何一部分）。平台对平台服务的修改或终止对用户和任何第三人不承担任何责任。平台有权基于合法的理由，终止用户的账号、密码或使用平台服务，或删除、转移用户存储、发布在平台的内容，平台采取上述行为均不需通知，并且对用户和任何第三人不承担任何责任。
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '@/components/header.vue'
export default {
  components: { Header},
  data() {
    return {

    }
  }
}
</script>

<style lang="stylus" scoped>
.statement-wrap,
.protocol-wrap {
  box-sizing: border-box;
  padding: 24px;
  width: 100%;
  background: #fff;
  font-size: 16px;
  color: #7a8399;
  word-wrap: break-word;
  word-break: normal;
}
.statement-wrap > p,
.protocol-wrap > p {
  text-indent:2em;
}
</style>